import * as React from "react";
import { GuestFooter } from "../Guest/GuestFooter";
import { DefaultVitalographLogo } from "../Core/VitalographLogo";

export const NoUser = () => {
    return (
        <div className="middle-box text-center animated fadeInDown">
            <div>
                <div>
                    <h1 className="logo-name">
                        <img src={`data:image/png;base64,${DefaultVitalographLogo}`} alt="Vitalograph Logo" />
                    </h1>
                </div>
                <h3>No User Account Set Up</h3>
                <p>
                    This user has not been added to this web portal. Please contact your site administrator.
                </p>

                <GuestFooter />
            </div>
        </div>
    );
}
